import { render, staticRenderFns } from "./RightBottomPopup.vue?vue&type=template&id=64430967&"
import script from "./RightBottomPopup.vue?vue&type=script&lang=js&"
export * from "./RightBottomPopup.vue?vue&type=script&lang=js&"
import style0 from "./RightBottomPopup.vue?vue&type=style&index=0&id=64430967&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports